<section class="rt-mig" role="note" aria-labelledby="rt-mig-title">
  <svg class="rt-mig-icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
    <path d="m3 11 18-5v12L3 14v-3z" />
    <path d="M11.6 16.8a3 3 0 1 1-5.8-1.6" />
  </svg>
  <div class="rt-mig-body">
    <h3 id="rt-mig-title" class="rt-mig-title">{{ 'app.migration_notice.title' | translate }}</h3>
    <p class="rt-mig-text">
      <span [innerHTML]="'app.migration_notice.summary' | translate"></span>
      <ng-container *ngIf="!expanded">
        <button #readMore type="button" class="rt-mig-toggle" aria-controls="rt-mig-more" [attr.aria-expanded]="expanded"
          (click)="toggle()">{{ 'app.migration_notice.read_more' | translate }}</button>
      </ng-container>
    </p>
    <!-- tabindex="-1": focusable from code only, so toggle() can land focus on the
         revealed text instead of losing it with the removed Read more button. -->
    <div #more id="rt-mig-more" tabindex="-1" *ngIf="expanded">
      <p class="rt-mig-text">{{ 'app.migration_notice.coordination' | translate }}</p>
      <p class="rt-mig-text" [innerHTML]="'app.migration_notice.contact' | translate: contactParams"></p>
      <p class="rt-mig-text">{{ 'app.migration_notice.thanks' | translate }}</p>
      <button type="button" class="rt-mig-toggle rt-mig-toggle-block" aria-controls="rt-mig-more"
        [attr.aria-expanded]="expanded" (click)="toggle()">{{ 'app.migration_notice.show_less' | translate }}</button>
    </div>
  </div>
</section>
